export const getItemObjByIdFromList = (itemId, itemsList) => {
  return itemsList.find(item => item.id === itemId);
};
export const getItemNameByIdFromList = (itemId, itemsList, notFoundMsg) => {
  const itemObj = getItemObjByIdFromList(itemId, itemsList);
  return itemObj ? itemObj.name : notFoundMsg;
};